/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Silent_Golden_Goose_DreamInputs */

const en_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation limit reached`)
};

const id_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas aktivasi tercapai`)
};

const ms_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Had pengaktifan dicapai`)
};

const ca_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'ha assolit el límit d'activacions`)
};

const cs_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosažen limit aktivací`)
};

const da_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveringsgrænse nået`)
};

const de_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivierungslimit erreicht`)
};

const et_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveerimiste piirang saavutatud`)
};

const es_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alcanzó el límite de activaciones`)
};

const fr_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite d’activations atteinte`)
};

const hr_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosegnuto ograničenje aktivacija`)
};

const it_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite di attivazione raggiunto`)
};

const lv_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sasniegts aktivizēšanas limits`)
};

const lt_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasiekta aktyvavimo riba`)
};

const hu_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiválási korlát elérve`)
};

const nl_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activeringslimiet bereikt`)
};

const nb_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveringsgrense nådd`)
};

const pl_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięto limit aktywacji`)
};

const pt_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite de ativação atingido`)
};

const ro_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limita de activare atinsă`)
};

const sk_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosiahnutý limit aktivácií`)
};

const sl_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosežena omejitev aktivacij`)
};

const fi_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivointiraja saavutettu`)
};

const sv_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveringsgränsen har nåtts`)
};

const vi_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đạt đến giới hạn kích hoạt`)
};

const tr_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinleştirme sınırına ulaşıldı`)
};

const el_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έφτασε το όριο ενεργοποιήσεων`)
};

const bg_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достигнат е лимитът за активиране`)
};

const ru_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достигнут лимит активаций`)
};

const sr_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достигнут лимит активација`)
};

const uk_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнуто ліміту активацій`)
};

const ka_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გააქტიურების ლიმიტი ამოწურულია`)
};

const hi_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रियण सीमा पहुँच गई`)
};

const th_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถึงขีดจำกัดการเปิดใช้งานแล้ว`)
};

const ko_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성화 한도 도달`)
};

const zh_tw_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已達啟用次數上限`)
};

const ja_silent_golden_goose_dream = /** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーション制限に達しました`)
};

/** @type {(inputs: Silent_Golden_Goose_DreamInputs) => LocalizedString} */
const zh_silent_golden_goose_dream = en_silent_golden_goose_dream;

/**
* | output |
* | --- |
* | "Activation limit reached" |
*
* @param {Silent_Golden_Goose_DreamInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const silent_golden_goose_dream = /** @type {((inputs?: Silent_Golden_Goose_DreamInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Silent_Golden_Goose_DreamInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_silent_golden_goose_dream(inputs)
	if (locale === "ms") return ms_silent_golden_goose_dream(inputs)
	if (locale === "ca") return ca_silent_golden_goose_dream(inputs)
	if (locale === "cs") return cs_silent_golden_goose_dream(inputs)
	if (locale === "da") return da_silent_golden_goose_dream(inputs)
	if (locale === "de") return de_silent_golden_goose_dream(inputs)
	if (locale === "et") return et_silent_golden_goose_dream(inputs)
	if (locale === "es") return es_silent_golden_goose_dream(inputs)
	if (locale === "fr") return fr_silent_golden_goose_dream(inputs)
	if (locale === "hr") return hr_silent_golden_goose_dream(inputs)
	if (locale === "it") return it_silent_golden_goose_dream(inputs)
	if (locale === "lv") return lv_silent_golden_goose_dream(inputs)
	if (locale === "lt") return lt_silent_golden_goose_dream(inputs)
	if (locale === "hu") return hu_silent_golden_goose_dream(inputs)
	if (locale === "nl") return nl_silent_golden_goose_dream(inputs)
	if (locale === "nb") return nb_silent_golden_goose_dream(inputs)
	if (locale === "pl") return pl_silent_golden_goose_dream(inputs)
	if (locale === "pt") return pt_silent_golden_goose_dream(inputs)
	if (locale === "ro") return ro_silent_golden_goose_dream(inputs)
	if (locale === "sk") return sk_silent_golden_goose_dream(inputs)
	if (locale === "sl") return sl_silent_golden_goose_dream(inputs)
	if (locale === "fi") return fi_silent_golden_goose_dream(inputs)
	if (locale === "sv") return sv_silent_golden_goose_dream(inputs)
	if (locale === "vi") return vi_silent_golden_goose_dream(inputs)
	if (locale === "tr") return tr_silent_golden_goose_dream(inputs)
	if (locale === "el") return el_silent_golden_goose_dream(inputs)
	if (locale === "bg") return bg_silent_golden_goose_dream(inputs)
	if (locale === "ru") return ru_silent_golden_goose_dream(inputs)
	if (locale === "sr") return sr_silent_golden_goose_dream(inputs)
	if (locale === "uk") return uk_silent_golden_goose_dream(inputs)
	if (locale === "ka") return ka_silent_golden_goose_dream(inputs)
	if (locale === "hi") return hi_silent_golden_goose_dream(inputs)
	if (locale === "th") return th_silent_golden_goose_dream(inputs)
	if (locale === "ko") return ko_silent_golden_goose_dream(inputs)
	if (locale === "zh") return zh_silent_golden_goose_dream(inputs)
	if (locale === "zh-tw") return zh_tw_silent_golden_goose_dream(inputs)
	if (locale === "ja") return ja_silent_golden_goose_dream(inputs)
	return en_silent_golden_goose_dream(inputs)
});